import { adminLocalizationApi } from '@/api';
import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { usePopups } from '@/hooks';

export const useRelatedSections = () => {
  const { t } = useTranslation();
  const { showErrorToast } = usePopups();
  const [isCreating, setIsCreating] = useState(false);

  const handleGet = useCallback(async (parentQuestionnaireId) => {
    try {
      setIsCreating(true);
      return await adminLocalizationApi.getQuestionnaireSections({
        questionSectionTypeId: parentQuestionnaireId
      });
    } catch (e) {
      showErrorToast(e, true);
    } finally {
      setIsCreating(false);
    }
  }, []);

  return {
    handleGet,
    isCreating
  };
};
